<template>
  <v-card 
    class="pb-2"
    style="max-width: 100%; width: 100%"
  >
    <v-toolbar
      flat
    >
      <v-switch 
        v-if="editionMode || !enabled"
        v-model="enabled" 
        :label="$t('campaigns.label.emailNotifications')"
      ></v-switch>
      <v-chip-group v-else-if="!editionMode && enabled">
        <v-chip v-for="user in richNotifiedUsers" :key="user.username">
          {{ user.profilename }}
        </v-chip>
      </v-chip-group>
    </v-toolbar>
    <v-container v-if="editionMode && enabled" fluid class="py-0">
      <v-row>    
        <v-col :cols="editionMode ? 12 : 6" class="py-0">
          <v-subheader v-if="!editionMode" class="pl-0">
            {{ $t('campaigns.label.notifiedUsers') }}
          </v-subheader>
          <v-select
            dense
            v-if="editionMode"
            v-model="notifiedUsers"
            :items="users"
            item-text="profilename"
            item-value="username"
            multiple
            chips
            :hint="$t('campaigns.label.notifiedUsers')"
            persistent-hint
          ></v-select>
          <v-chip-group v-else>
            <v-chip v-for="user in richUsers" :key="user.username">
              {{ user.profilename }}
            </v-chip>
          </v-chip-group>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
export default {
  props: ["editionMode","emailNotifications", "jsonpath", "users"],
  computed: {
    richNotifiedUsers() {
      return this.editionMode || !this.notifiedUsers ? [] : this.notifiedUsers.map(username => {
        const result = this.users.find(user => user.username == username)
        if (!result) {
          return {username, profilename:"<user no longer exists>"}
        }
        return result
      })
    },
    enabled: {
      get() {
        return this.emailNotifications.enabled;
      },
      set(value) {
        this.$emit("change", {jsonpath: this.jsonpath, op: { name: "patch", value: { enabled: value }}})
      }
    },
    notifiedUsers: {
      get() {
        const notifiedUsers = this.emailNotifications.notifiedUsers;
        return notifiedUsers ? notifiedUsers : []
      },
      set(value) {
        this.$emit("change", {jsonpath: this.jsonpath, op: { name: "patch", value: { notifiedUsers: value }}})
      }
    },
  },
}
</script>